import { h } from 'preact';
import clsx from 'clsx';

const Content = ({ settings }) => {
  const {
    background,
    image,
    video,
    text,
    cta_text: ctaText,
    cta_link: ctaLink,
    desktop_layout: desktopLayout,
    hide_mobile: hideMobile,
    text_color: textColor
  } = settings;

  return (
    <div
      style={{
        background,
        backgroundImage: image ? `url(${image})` : background,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: textColor
      }}
      className={clsx(
        'items-center relative px-5 justify-center text-white text-center flex-col aspect-[2] col-span-2',
        desktopLayout,
        hideMobile ? 'hidden laptop:flex' : 'flex',
      )}
    >
      {video && (
        <div className="absolute inset-0 w-full h-full">
          <video
            loop
            muted
            autoPlay
            playsInline
            className="w-full h-full object-cover"
          >
            {video.sources.map((source, index) => (
              <source
                key={index}
                src={source.url}
                type={source.mime_type}
              ></source>
            ))}
          </video>
        </div>
      )}
      <div
        className="relative subheading rte"
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      />
      {ctaText && ctaLink && (
        <a
          href={ctaLink}
          className="tracking-[0.02em] text-white cta-small mt-5 underline relative"
        >
          {ctaText}
        </a>
      )}
    </div>
  );
};

export default Content;
